<template>
  <div>

    <!-- Loading -->
    <div class="text-center py-12" v-show="cargando">
      <v-progress-circular indeterminate color="blue darken-4" size="52"></v-progress-circular>
      <div class="caption grey--text mt-3">Cargando ranking...</div>
    </div>

    <div v-show="!cargando" class="pt-0">

      <!-- Header -->
      <div class="ranking-header mt-0">
        <div class="ranking-header-deco ranking-header-deco--1"></div>
        <div class="ranking-header-deco ranking-header-deco--2"></div>
        <div class="text-center pt-5 pb-4" style="position:relative">
          <v-icon color="blue darken-4" size="32" class="mb-1">mdi-trophy</v-icon>
          <div class="text-h6 font-weight-bold white--text">Ranking de Inscripciones</div>
          <div class="caption white--text mt-1" style="opacity:0.82">
            Mes de <strong>{{ getMes() }}</strong> &nbsp;·&nbsp; Sede <strong>{{ sedename }}</strong>
          </div>
          <div class="mt-3">
            <router-link to="rankingall" style="text-decoration:none">
              <v-btn x-small rounded outlined color="blue darken-4">
                <v-icon x-small left>mdi-chart-bar</v-icon>
                Tablero general
              </v-btn>
            </router-link>
          </div>
        </div>
      </div>

      <!-- Podio -->
      <v-container class="ranking-podio-container">
        <v-row justify="center" align="end" no-gutters class="ranking-podio-row">

          <!-- 2do lugar -->
          <v-col cols="4" class="text-center px-1">
            <div v-show="segundo.info.id" :title="getTitle(segundo)" class="ranking-card">
              <div class="ranking-badge silver-badge">2</div>
              <div class="ranking-avatar-wrap silver-ring">
                <img :src="segundo.info.foto" alt="ASESOR" class="ranking-avatar">
              </div>
              <div class="ranking-name mt-2">{{ segundo.info.nombre }}</div>
              <div class="ranking-score silver-score">{{ segundo.total }}</div>
              <div class="ranking-podium-bar silver-bar">
                <v-icon color="white" small>mdi-medal</v-icon>
              </div>
            </div>
          </v-col>

          <!-- 1er lugar -->
          <v-col cols="4" class="text-center px-1">
            <div v-show="primero.info.id" :title="getTitle(primero)" class="ranking-card ranking-card--first">
              <div class="ranking-badge gold-badge">
                <v-icon x-small color="white">mdi-crown</v-icon>
              </div>
              <div class="ranking-avatar-wrap gold-ring">
                <img :src="primero.info.foto" alt="ASESOR" class="ranking-avatar ranking-avatar--first">
              </div>
              <div class="ranking-name ranking-name--first mt-2">{{ primero.info.nombre }}</div>
              <div class="ranking-score gold-score">{{ primero.total }}</div>
              <div class="ranking-podium-bar gold-bar">
                <v-icon color="white" small>mdi-trophy</v-icon>
              </div>
            </div>
          </v-col>

          <!-- 3er lugar -->
          <v-col cols="4" class="text-center px-1">
            <div v-show="tercero.info.id" :title="getTitle(tercero)" class="ranking-card">
              <div class="ranking-badge bronze-badge">3</div>
              <div class="ranking-avatar-wrap bronze-ring">
                <img :src="tercero.info.foto" alt="ASESOR" class="ranking-avatar">
              </div>
              <div class="ranking-name mt-2">{{ tercero.info.nombre }}</div>
              <div class="ranking-score bronze-score">{{ tercero.total }}</div>
              <div class="ranking-podium-bar bronze-bar">
                <v-icon color="white" small>mdi-medal-outline</v-icon>
              </div>
            </div>
          </v-col>

        </v-row>
      </v-container>
    </div>

  </div>
</template>

<style>
/* ── Header ── */
.ranking-header {
  background:
    linear-gradient(135deg, #0d47a1 0%, #1565c0 48%, #1e88e5 100%);
  position: relative;
  overflow: hidden;
  border-left: 4px solid #0d47a1;
  border-bottom: 1px solid #0b3d86;
}
.ranking-header-deco {
  position: absolute;
  height: 1px;
  background: rgba(255, 255, 255, 0.18);
  transform: rotate(-18deg);
}
.ranking-header-deco--1 {
  width: 220px;
  top: 34px; right: -48px;
}
.ranking-header-deco--2 {
  width: 160px;
  bottom: 28px; left: -38px;
}

/* ── Podio layout ── */
.ranking-podio-container {
  padding-top: 12px;
}
.ranking-podio-row {
  min-height: 280px;
}

/* ── Card base ── */
.ranking-card {
  position: relative;
  background: #ffffff;
  border-radius: 8px 8px 0 0;
  padding: 14px 6px 0;
  box-shadow: 0 2px 10px rgba(13, 71, 161, 0.14);
  border-top: 2px solid #1e88e5;
}
.ranking-card--first {
  transform: translateY(-20px);
  box-shadow: 0 8px 24px rgba(13, 71, 161, 0.22);
  z-index: 1;
  border-top: 3px solid #0d47a1;
}

/* ── Badge número ── */
.ranking-badge {
  position: absolute;
  top: -11px;
  right: -6px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  font-size: 12px;
  font-weight: 800;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(13, 71, 161, 0.24);
}
.gold-badge   { background: #0d47a1; }
.silver-badge { background: #1976d2; }
.bronze-badge { background: #42a5f5; }

/* ── Avatar ── */
.ranking-avatar-wrap {
  width: 70px; height: 70px;
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto;
  border: 3px solid;
}
.ranking-avatar-wrap.ranking-avatar-wrap--first,
.gold-ring   { border-color: #0d47a1; width: 84px; height: 84px; }
.silver-ring { border-color: #1976d2; }
.bronze-ring { border-color: #42a5f5; }

.ranking-avatar {
  width: 100%; height: 100%;
  object-fit: cover;
  object-position: top;
}

/* ── Nombre ── */
.ranking-name {
  font-size: 11px;
  font-weight: 600;
  color: #374151;
  line-height: 1.3;
  min-height: 28px;
}
.ranking-name--first {
  font-size: 12px;
  color: #0d47a1;
}

/* ── Puntaje ── */
.ranking-score {
  font-size: 26px;
  font-weight: 900;
  line-height: 1.1;
  margin-top: 2px;
}
.gold-score   { color: #0d47a1; }
.silver-score { color: #1976d2; }
.bronze-score { color: #42a5f5; }

/* ── Barra de podio ── */
.ranking-podium-bar {
  margin-top: 8px;
  border-radius: 0 0 8px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.gold-bar   { background: linear-gradient(to bottom, #0d47a1, #08366f); height: 80px; }
.silver-bar { background: linear-gradient(to bottom, #1976d2, #0d47a1); height: 56px; }
.bronze-bar { background: linear-gradient(to bottom, #42a5f5, #1976d2); height: 36px; }
</style>

<script>
import gql from 'graphql-tag'
export default {
  components: {},
  data() {
    return {
      location_user_pick: process.env.VUE_APP_URL_USERPICK,
      sedename:'',
      cargando:true,
      primero:{info:{}},
      segundo:{info:{}},
      tercero:{info:{}},
    };
  },
  watch:{
      '$store.state.CARGO':function( a ){
          this.listenercargo( a );
      }
  },
  methods:{
      getMes(){
          var date = new Date();
          var m = date.getMonth();
          if( m == 0 ) return 'Enero';
          else if( m == 1 ) return 'Febrero';
          else if( m == 2 ) return 'Marzo';
          else if( m == 3 ) return 'Abril';
          else if( m == 4 ) return 'Mayo';
          else if( m == 5 ) return 'Junio';
          else if( m == 6 ) return 'Julio';
          else if( m == 7 ) return 'Agosto';
          else if( m == 8 ) return 'Septiembre';
          else if( m == 9 ) return 'Octubre';
          else if( m == 10 ) return 'Noviembre';
          else if( m == 11 ) return 'Diciembre';
      },
      listenercargo( a ){
          if( !a ) return;
          if( this.sedename == a.sede.nombre ) return;
          this.sedename = a.sede.nombre;
          this.getInsBySede( a.idsede );
      },
      getTitle( user ){
        var ps = user.dip+user.maes+user.esp;
        var t = `Programas: ${ps}, Cursos: ${user.cur}`;
        return t;
      },
      getInsBySede( idsede ){
          this.primero = {info:{}};
          this.segundo = {info:{}};
          this.tercero = {info:{}};
          this.cargando = true;
          var date = new Date();
          var m = date.getMonth()+1;
          var d = date.getDate();
          var a = date.getFullYear();
          if( d == 1 ) d +=1;
          if( m < 10 ) m = '0'+m;
          if( d < 10 ) d = '0'+d;
          var ini = a+'-'+m+'-01';
          var fin = a+'-'+m+'-'+d;

          var sql = gql`
            query{
                getInscripcionesBySede(sede:${idsede},fechas:{fecha_ini:"${ini}",fecha_fin:"${fin}"}){
                    id
                    estado_ins
                    asesor{id,nombres,pri_apellido,seg_apellido,usuario{foto}}
                    programa{id,postgrado{id,nombre,categoria{id,nombre}}}
                }
            }`;
          this.getDatos( sql,idsede );
      },
      getDatos( sql,idsede ){
          var vue = this;
          var asesores = [{info:{},dip:0,maes:0,esp:0,cur:0,total:0}]
          this.$apollo.mutate({
            mutation: sql,
          }).then((data) => {
            var ins = data.data.getInscripcionesBySede;
            ins = ins.filter(function(e){
              if( idsede == 2 ){ // excluimos formacion continua
                var fc = [5071,72,5281,8382]
                return e.estado_ins > 0 && !fc.includes(e.asesor.id); // quitar ! para listar solo fc ;)
              }else{
                return e.estado_ins > 0;
              }
            });
            ins.forEach(e => {
                var nom = e.asesor.nombres+' '+e.asesor.pri_apellido;
                if( e.asesor.seg_apellido ) nom += ' '+e.asesor.seg_apellido;

                // window.console.log('>>>>asse', e.asesor);
                if(!e.asesor.usuario) e.asesor.usuario = {}


                var ase = asesores.find( x => x.info.id == e.asesor.id );
                if( !ase ) {
                    var img;
                    if( e.asesor.usuario.foto && e.asesor.usuario.foto.includes('.') ) img = this.location_user_pick+''+e.asesor.usuario.foto;
                    else img = this.location_user_pick+'userdefault.png';
                    asesores.push( {info:{id:e.asesor.id,nombre:nom,foto:img},dip:0,maes:0,esp:0,cur:0} );
                }
                ase = asesores.find( x => x.info.id == e.asesor.id );

                if( e.programa.postgrado.categoria.id == 1 ) ase.dip += 1;
                else if( e.programa.postgrado.categoria.id == 2 ) ase.esp += 1;
                else if( e.programa.postgrado.categoria.id == 3 ) ase.maes += 1;
                else ase.cur += 1;
                ase.total = ase.dip+ase.esp+ase.maes+ase.cur;

                //window.console.log( "RANKIN: ",window.stringifyObject(e) )
            });
            asesores.sort( function(a,b){
                if( a.total > b.total ) return -1;
                if( a.total < b.total ) return 1;
                return 0;
            });
            if( asesores.length > 2 ) {
                this.primero = asesores[0];
                this.segundo = asesores[1];
                this.tercero = asesores[2];
            }
            else if( asesores.length > 1 ) {
                this.primero = asesores[0];
                this.segundo = asesores[1];
            }
            else if( asesores.length > 0 ) {
                this.primero = asesores[0];
            }
            // window.console.log( "RANKIN: ",asesores )
            this.cargando = false;
          }).catch((error) => {
            window.console.error(error);
            vue.cargando = false;
          })
      }
  },
  mounted() {
      this.listenercargo( this.$store.state.CARGO );
  },
};
</script>
